import * as Sentry from "@sentry/gatsby"

import {
  scrubBrowserBreadcrumb,
  scrubBrowserEvent,
} from "./src/helpers/sentry-client"
import { sentryBaseConfig } from "./src/helpers/sentry-config"

// Keep error diagnostics actionable while excluding user and form data.
// https://docs.sentry.io/platforms/javascript/guides/gatsby/configuration/options/#dataCollection

Sentry.init({
  ...sentryBaseConfig,
  beforeBreadcrumb: scrubBrowserBreadcrumb,
  beforeSend: scrubBrowserEvent,
  dataCollection: {
    cookies: false,
    databaseQueryData: false,
    genAI: {
      inputs: false,
      outputs: false,
    },
    graphQL: {
      document: false,
      variables: false,
    },
    httpBodies: [],
    httpHeaders: {
      request: false,
      response: false,
    },
    stackFrameVariables: false,
    urlQueryParams: false,
    userInfo: false,
  },
  integrations: (defaultIntegrations) =>
    defaultIntegrations.filter(({ name }) => name !== "BrowserSession"),
})
